<template>
	<ViewUiCalloutIcon
		class="view-ui-state-nocheckins"
		iconFilename="pin.svg"
		v-bind:message="'A history of user checkins<br />will appear here'"
	>
		<div class="actions push-top-xl">
			<ViewUiButtonBack class="button-tertiary" />
		</div>
	</ViewUiCalloutIcon>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateNoCheckins extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-ui-state-nocheckins {
		aspect-ratio: auto;
		margin: 0;
	}
</style>
